import { Fragment, memo } from "react";
import "./index.less";


const TextTagged = memo(({ text, onClick }) => {
  if (!text) {
    return null;
  }
  const regex = /<%\d+%>/g;
  const parts = text.split(regex);

  return (
    <Fragment>
      {parts.map((part, index) => {
        const number = index + 1;
        return (
          part && (
            <Fragment key={index}>
              {part}
              {number < parts.length && (
                <span
                  className="card_reference__text__tag"
                  onClick={() => onClick?.(index)}
                >
                  {number}
                </span>
              )}
            </Fragment>
          )
        );
      })}
    </Fragment>
  );
});

export default TextTagged;
